const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/utils/appointments.ts';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';
import moment from 'moment/moment';
import { KISIM_STD_DATE_TIME_FORMAT, KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';

export const manipulateStructuredAppointment = (appointment: StructuredAppointment) => {
    const { EINTRITTDAT, EINTRITTTIME } = appointment;
    // Operation appointments have a STARTDAT that is in context of when the operation starts.
    // Because appointments for the user of this app should indicate when they actually have to arrive (and STARTDAT
    // is generally used for that), the STARTDAT is manipulated here so it is transparent for all existing logic that
    // uses STARTDAT. For example, the structure of dates to render the list of appointments.
    if (EINTRITTDAT && EINTRITTTIME) {
        const eintrittDatPatient = moment(`${EINTRITTDAT} ${EINTRITTTIME}`, KISIM_STD_DATE_TIME_FORMAT).format(
            KISIM_TIME_FORMAT
        );
        // Operation appointments have a STARTDAT that is in context of when the operation starts.
        // Because appointments for the user of this app should indicate when they actually have to arrive (and STARTDAT
        // is generally used for that), the STARTDAT is manipulated here to make it transparent for all existing logic that
        // uses STARTDAT. For example, the structure of dates to render the list of appointments.
        appointment.STARTDAT = eintrittDatPatient;
        // This makes the value for Eintritt for patient a lot easier to access
        appointment.EINTRITTDAT_PATIENT = eintrittDatPatient;
    }
};
